import React from "react";
import { Field } from "formik";
import { InputContainer } from "styles/components/AnimatedInput";

const TextInput = (props) => {

  const handleChange = (val) => {
    //props?.onChangeHandler(val)
  }

  return (
    <Field name={props?.name}>
      {({ field, meta, form }) => {
        return (
          <InputContainer className={props.className}>
            <div className="input-container">
              <input
                type={props?.type}
                className={`${meta.touched && meta.error ? "error" : ""}`}
                name={field.name}
                maxLength={props?.maxLength}
                disabled={props?.disabled}
                placeholder={props?.displayFloatingLabel === false ? props?.placeholder : undefined}
                onKeyUp={(evt) => {
                  if (props?.name === "businessUrl" || props?.inputType === "password" || props?.type === "password" || props?.name === "email" || props?.name === "businessDesc" || props?.name?.toLowerCase().includes('email')) {
                    form.setFieldValue(props?.name, evt.target.value);
                    props?.onChangeHandler && props?.onChangeHandler(evt.target.value, field.value)
                  } else {
                    if (props?.inputType === "CompanyName" || props?.name === "orderId" || props?.name === "poNumber" || props?.inputType === "poNumber") {
                      // const setValue = evt.target.value.replace(/[^0-9a-zA-Z&@#%!*$+_-~"''\s]/g, '')
                      //replace(/[\d,.\ ]/g, '')
                      const setValue = evt.target.value.replaceAll(",", "")
                      let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                      form.setFieldValue(props?.name, firstLetterCap);
                      // props?.onChangeHandler && props?.onChangeHandler(firstLetterCap,field.value)  
                    } else if (props?.name?.toLowerCase().includes('zip')) {
                      const setValue = evt.target.value.replace(/[^0-9a-zA-Z\s]/g, '')
                      let setValueUpperCase = setValue.toUpperCase()
                      form.setFieldValue(props?.name, setValueUpperCase)
                      props?.onChangeHandler && props?.onChangeHandler(evt.target.value, field.value)
                    } else if (props?.inputType === "onlyText") {
                      const setValue = evt.target.value.replace(/[^a-zA-Z\s]/g, '')
                      let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                      form.setFieldValue(props?.name, firstLetterCap)
                    } else if (props?.inputType === "address" || props?.inputType === "addressText") {
                      let firstLetterCap = evt.target.value.charAt(0).toUpperCase() + evt.target.value.slice(1)
                      form.setFieldValue(props?.name, firstLetterCap);
                      props?.onChangeHandler && props?.onChangeHandler(firstLetterCap, field.value)
                    } else {
                      if (props?.inputType === "returnText") {
                        form.setFieldValue(props?.name, evt.target.value);
                        props?.onChangeHandler && props?.onChangeHandler(evt.target.value, field.value)
                      }
                      else if (props?.name !== "password" && props?.name !== 'confirmPassword') {
                        const setValue = evt.target.value.replace(/[^0-9a-zA-Z\s]/g, '')
                        let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                        form.setFieldValue(props?.name, firstLetterCap)
                      }
                    }
                  }
                }}
                onBlurCapture={() => {
                  props?.blurHandler && props?.blurHandler(field.value)
                }}
                onChange={handleChange}
                {...field}
                value={props?.value !== undefined && props?.value !== null ? props?.value : (field.value || "")}
              />
              {props?.displayFloatingLabel !== false && (
                <label className={field.value && 'filled'} htmlFor={props?.name} style={{ "min-width": "235px" }}>
                  {props?.placeholder}
                </label>
              )}

              {meta.touched && meta.error && (
                <p name={props?.name + "Error"} className="error-message">{meta.error}</p>
              )}
            </div>
          </InputContainer>
        );
      }}
    </Field>
  );
};

export default TextInput;
